import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tp0003',
    ecrans: ['00-2']
});
